import initialState from './state'
import { persistAuthFlowPayload } from '@/lib/auth-flow-persistence'
import {
	PendingAccountConfirmation,
	ProfileLoading,
	ResetState,
	SetAccountRecoverCredentialsId,
	SetAccountRecoverLoginId,
	SetAuthFlowPayload,
	SetAuthFlowWithProvider,
	SetAuthReady,
	SetAuthToken,
	SetCurrentCredentials,
	SetCurrentSessionId,
	SetRefreshToken,
	SetSessions,
	SetUserId,
	UpdateCredentials,
	UpdateProfiles,
	UpdateSessions,
	SetRefreshDeadline,
} from './mutation-type'

const createBasicSetter = key => (state, value) => {
	state[key] = value
}

export default {
	[ResetState]: state => {
		for (const [key, value] of Object.entries(initialState)) {
			state[key] = value
		}
		// authFlowPayload is reset above like every other field; keep the
		// sessionStorage mirror (see lib/auth-flow-persistence.js) in sync so a
		// stale flow can't leak into a later, unrelated visit in the same tab.
		// The OAuth-flow logout path immediately re-dispatches
		// setAuthFlowPayload afterwards, which re-persists it via the mutation
		// below, so this doesn't affect that case.
		persistAuthFlowPayload(null)
	},
	[ProfileLoading]: createBasicSetter('profileLoading'),
	[SetAccountRecoverCredentialsId]: createBasicSetter('accountRecoverCredentialsId'),
	[SetAccountRecoverLoginId]: createBasicSetter('accountRecoverLoginId'),
	[SetAuthFlowPayload]: (state, value) => {
		state.authFlowPayload = value
		persistAuthFlowPayload(value)
	},
	[SetAuthFlowWithProvider]: createBasicSetter('authFlowWithProvider'),
	[SetAuthToken]: createBasicSetter('authToken'),
	[SetCurrentCredentials]: createBasicSetter('currentCredentialsId'),
	[SetCurrentSessionId]: createBasicSetter('currentSessionId'),
	[SetRefreshToken]: createBasicSetter('refreshToken'),
	[SetUserId]: createBasicSetter('userId'),
	[PendingAccountConfirmation]: createBasicSetter('pendingAccountConfirmation'),
	[SetSessions]: createBasicSetter('sessions'),
	[SetAuthReady]: createBasicSetter('authReady'),
	[SetRefreshDeadline]: createBasicSetter('refreshDeadline'),
	[UpdateProfiles]: (state, value) => {
		state.profiles = state.profiles.length === 0
			? [ value ]
			: state.profiles.map(profile => {
				return profile._id === value._id
					? { ...profile, ...value }
					: profile
			})
	},
	[UpdateCredentials]: (state, value) => {
		state.credentials = state.credentials.length === 0
			? [ value ]
			: state.credentials.map(entry => {
				if (entry._id !== value._id) return entry
				let _value = { ...value }
				const newMetadata = _value.metadata
				delete _value.metadata
				const res = { ...entry, ..._value }
				if (newMetadata) {
					res.metadata = { ...res.metadata, ...newMetadata }
				}
				return res
			})
	},
	[UpdateSessions]: (state, value) => {
		state.sessions = state.sessions.length === 0
			? [ value ]
			: state.sessions.map(entry => {
				return entry._id === value._id
					? { ...entry, ...value }
					: entry
			})
	},
}
